<template>
    <div class="Power_report-container-single">
        <me-collapes @collapesCb="collapesCb" :treeTitle="'采集点选择'">
            <div style="height: 750px">
                <div class="tree-wrap">
                    <me-tree
                        ref="myTree"
                        :treeData="data"
                        :treeLoading="treeLoading"
                        :treeToolBar="false"
                        :defaultProps="defaultProps"
                        :defaultExpandedKeys="defaultCheckKeys"
                        :nodeKey="'tree_unit_id'"
                        :title="'采集点选择'"
                        :defaultExpandAll="false"
                        @handleTreeNodeClick="handleTreeNodeClick"
                    ></me-tree>
                </div>
            </div>
        </me-collapes>
        <div
            class="power-tab right_container leader-tab"
            :style="{ width: width }"
        >
            <el-tabs v-model="tabVal" type="card" @tab-click="handleTabClick">
                <el-tab-pane label="实时负荷" name="port"></el-tab-pane>
                <el-tab-pane label="日报" name="day"></el-tab-pane>
                <el-tab-pane label="月报" name="month"></el-tab-pane>
                <el-tab-pane label="年报" name="year"></el-tab-pane>
            </el-tabs>
            <power-table-with
                v-show="curTab == 1"
                :curTab="curTab"
                :tabVal="tabVal"
                :curPointId="curPointId"
                :pointName="pointName"
            ></power-table-with>
            <power-table-no
                v-show="curTab == 2"
                :curTab="curTab"
                :tabVal="tabVal"
                :curPointId="curPointId"
                :pointName="pointName"
            ></power-table-no>
        </div>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import Collapes from "@/comon/components/collapse-block.vue";
// import moment from "moment";
// import dayjs from "dayjs";
import { getTreeUnitList } from "@/http/express/unit-express.js";
import * as api from "@/http/api.js";
import PowerTableWith from "./components/power_table_with";
import PowerTableNo from "./components/power_table_no";
export default {
    components: {
        "me-tree": Tree,
        "me-collapes": Collapes,
        "power-table-with": PowerTableWith,
        "power-table-no": PowerTableNo
    },
    filters: {
        // 2. 局部过滤器
        floatFormat(value) {
            return parseInt(value * 100) / 100;
        }
    },
    data() {
        return {
            tabVal: "port",
            data: [],
            treeLoading: false,
            defaultProps: {
                children: "childList",
                label: "tree_unit_name"
            },
            defaultCheckKeys: [],
            pointName: "",
            nodeKey: "point_id",
            systemDate: {},
            width: "calc(100% - 370px)",
            curTab: 1,
            curPointId: ""
        };
    },
    created() {
        this.getUnitPointList();
    },
    methods: {
        /**
         * 格式化tree disabled状态；
         */
        tickMenuIdFilter: () => {
            let resultArr = new Array();
            let firstPoint = new Object();
            let getTickMenuId = function(obj) {
                if (
                    undefined === obj ||
                    null === obj ||
                    !(obj instanceof Object)
                ) {
                    return;
                }
                if (obj.state === "1") {
                    //实采集点
                    obj.disabled = true;
                    resultArr.push(obj.id);
                } else if (obj.state === "0") {
                    //虚点
                    if (!firstPoint.tree_unit_id) {
                        firstPoint = obj;
                    }
                }

                if (null != obj.childList && obj.childList instanceof Array) {
                    for (let child of obj.childList) {
                        getTickMenuId(child);
                    }
                }
            };

            return {
                filter: function(arr) {
                    if (!(arr instanceof Array)) {
                        return false;
                    }
                    resultArr = new Array();
                    firstPoint = new Object();
                    for (let rootMenu of arr) {
                        getTickMenuId(rootMenu);
                    }
                    return { tree: resultArr, firstPoint: firstPoint };
                }
            };
        },
        handleTreeNodeClick(select) {
            // if (select.state == '1') {
            //     this.curTab = 2;
            // } else if (select.state == '0') {
            //     this.curTab = 1;
            // }
            this.defaultCheckKeys = [
                this.$refs.myTree.$refs.tree.getCurrentKey()
            ];
            this.curPointId = this.$refs.myTree.$refs.tree.getCurrentKey();
            this.pointName = select.tree_unit_name;
        },
        /**
         * 获取采集点信息
         */
        getUnitPointList() {
            this.treeLoading = true;
            getTreeUnitList().then(res => {
                if (res && res.error_code === "0") {
                    this.data = res.bus_json;
                    // let formatData = this.tickMenuIdFilter().filter(
                    //     res.bus_json
                    // );
                    // this.defaultCheckKeys = [
                    //     formatData.firstPoint.tree_unit_id,
                    // ];
                    const firstPoint = res.bus_json && res.bus_json[0];
                    // this.defaultCheckKeys = [
                    //     res.bus_json &&
                    //         res.bus_json[0] &&
                    //         res.bus_json[0].tree_unit_id,
                    // ];
                    this.defaultCheckKeys = [firstPoint.tree_unit_id];
                    this.curPointId = firstPoint.tree_unit_id;
                    this.pointName = firstPoint.tree_unit_name;
                    this.$nextTick(() => {
                        this.$refs.myTree.$refs.tree.setCurrentKey(
                            firstPoint.tree_unit_id
                        );
                    });
                    this.tabVal = "port";
                    // if (formatData.firstPoint.state == '1') {
                    //     this.curTab = 2;
                    // } else if (formatData.firstPoint.state == '0') {
                    //     this.curTab = 1;
                    // }
                }
                this.treeLoading = false;
            });
        },
        /**
         * 日月年tab切换回调事件
         */
        handleTabClick(tab, event) {
            this.nextTimeDisabled = true;
            if (tab.name === "port") {
                this.tabVal = "port";
            } else if (tab.name === "day") {
                //this.time = this.systemDate.sysdate;
                this.tabVal = "day";
            } else if (tab.name === "month") {
                //this.time = this.systemDate.sysdate3;
                this.tabVal = "month";
            } else {
                //this.time = this.systemDate.sysdate4;
                this.tabVal = "year";
            }
        },
        /**
         * 监听树结构收起展开
         */
        collapesCb(collapes) {
            this.width = collapes ? "calc(100% - 370px)" : "calc(100% - 56px)";
        }
    }
};
</script>
<style lang="scss">
.el-tabs__item {
    color: #fff;
}
.el-tabs--card {
    margin: 0;
}
.Power_report-container-single {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    .active-table {
        /*background: #ff7455 !important;*/
        /*color: #fff !important;*/
        /*border-color: #ff7455 !important;*/
    }
    .active-table-data {
        /*background: #083472 !important;*/
        /*color: #56fcff !important;*/
        /*border-color: #083472 !important;*/
    }
    // .tree-wrap {
    //     width: 280px;
    //     // height: 100%;
    //     padding-bottom: 70px;
    //     box-sizing: border-box;
    //     overflow: hidden;
    //     box-sizing: border-box;
    //     border-radius: 5px;
    // }
    .tree-wrap {
        height: 100%;
        // overflow: hidden;
        height: calc(100% - 10px);
        box-sizing: border-box;
    }
    .right_container {
        height: 100%;
        // // margin-top: 5px;
        // margin: 0 30px 0 0;
        // box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        // border-radius: 5px;
        // box-sizing: border-box;
        // transition: width 500ms;
        .el-tabs--card {
            margin: 0;
        }
    }
}
// .is-top .is-active {
//     /*color: #56fcff !important;*/
// }
.power-tab {
    margin: 4px 0 0 0;
}
</style>
